import "vant/es/toast/style";
import _Toast from "vant/es/toast";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/componentImg/addr_icon.png';
import _imports_1 from '@/assets/componentImg/tag_icon.png';

const _withScopeId = n => (_pushScopeId("data-v-57c1dade"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "publish-container"
};
const _hoisted_2 = {
  class: "category-section line-section"
};
const _hoisted_3 = {
  key: 0,
  class: "nimin-fatie"
};

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label"
}, "匿名发帖", -1));

const _hoisted_5 = {
  class: "submit-wrap"
};
const _hoisted_6 = {
  class: "btn-wrap"
};
const _hoisted_7 = {
  class: "add-btn"
};

const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1));

const _hoisted_9 = {
  class: "add-btn"
};

const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1));

const _hoisted_11 = /*#__PURE__*/_createTextVNode("提交");

const _hoisted_12 = {
  class: "content-declare-panel"
};
const _hoisted_13 = {
  class: "panel-header"
};

const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "panel-title"
}, "内容声明设置", -1));

const _hoisted_15 = {
  class: "panel-body"
};
const _hoisted_16 = {
  class: "option-group"
};

const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "group-label"
}, [/*#__PURE__*/_createTextVNode("合规声明 "), /*#__PURE__*/_createElementVNode("span", {
  class: "required-mark"
}, "*必选")], -1));

const _hoisted_18 = ["onClick"];
const _hoisted_19 = {
  class: "option-name"
};
const _hoisted_20 = {
  class: "option-group"
};

const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "group-label"
}, [/*#__PURE__*/_createTextVNode("风险提示 "), /*#__PURE__*/_createElementVNode("span", {
  class: "optional-mark"
}, "可选")], -1));

const _hoisted_22 = ["onClick"];
const _hoisted_23 = {
  class: "option-name"
};
const _hoisted_24 = {
  class: "panel-footer"
};

const _hoisted_25 = /*#__PURE__*/_createTextVNode("确定");

import { reactive, ref, onMounted, computed } from 'vue';
import CPage from '@/views/CPage.vue';
import UploadView from '@/components/help/upload-view.vue';
import SelectLocationView from '@/components/help/select-location-view.vue';
import SelectTagView from '@/components/channel/select-tag-view.vue';
import throttle from 'lodash/throttle';
import composition from '@/composition';
import ua from '@/utils/platform';
import BindPhone from '@/components/common/bind-phone.vue';
import PublishForm from '@/components/publish/publish-form.vue';
/**
 * @typedef IConfigResultDataConfig
 * @prop {number} id
 * @prop {number} tagId
 * @prop {string} content
 * @prop {number} type
 * @prop {number} isRequire
 * @prop {any} picSize
 */

/**
 * @typedef IConfigResultData
 * @prop {number} tagId
 * @prop {number} isConfig
 * @prop {number} isSno
 * @prop {IConfigResultDataConfig[]} configList
 */

/**
 * @typedef IConfigResult
 * @prop {number} ret
 * @prop {string} msg
 * @prop {IConfigResultData} data
 * @prop {number} timestamp
 * @prop {any} pageData
 */

export default {
  setup(__props) {
    const {
      store,
      request,
      fs_device,
      getQueryString,
      openCustomPage,
      wxShare
    } = composition();
    store.dispatch('_initApp'); // 参数

    const query = getQueryString(); // 频道id

    const cid = ref(0); // 话题id

    const tid = ref(0);
    cid.value = query.cid;
    tid.value = query.tid;

    if (cid.value == 771) {
      tid.value = 2521;
    }

    if (cid.value == 795) {
      tid.value = 2590;
    } // 表单组件实例（表单渲染、弹窗、校验与提交均封装在 publish-form 内部）


    const publishFormRef = ref(null);
    onMounted(() => {
      wxShare(document.title);
    }); // 能否编辑话题

    const canEditTag = ref(true); // 频道

    const categroyItem = ref({
      id: 0
    }); // 上传图片

    const uploader = ref(null); // 表单

    const form = reactive({
      type: categroyItem.value.type,
      // 类型
      content: '',
      // 内容
      tagId: 0,
      // 话题
      address: '',
      // 地址
      location: '',
      // 经纬度
      tagName: '',

      /**@type {IConfigResult | null} */
      tagRes: null
    });
    const anonymous = ref(false); // 是否匿名发帖
    // 内容声明设置

    const contentDeclareShow = ref(false);
    const complianceStatement = ref('');
    const riskWarning = ref(''); // 合规声明类选项

    const complianceOptions = [{
      name: '含AI生成内容',
      value: 'AI'
    }, {
      name: '含虚构演绎内容',
      value: 'FICTION'
    }, {
      name: '内容含营销消息',
      value: 'MARKETING'
    }, {
      name: '内容为转载',
      value: 'REPOST'
    }, {
      name: '个人观点，仅供参考',
      value: 'PERSONAL_OPINION'
    }, {
      name: '内容无需标注',
      value: 'NONE'
    }]; // 风险提示类选项

    const riskWarningOptions = [{
      name: '内容可能引人不适，请谨慎观看',
      value: 'UNCOMFORTABLE'
    }, {
      name: '内容含有高危险行为，请勿模仿',
      value: 'HIGH_RISK'
    }, {
      name: '请理性适度消费',
      value: 'RATIONAL_CONSUMPTION'
    }, {
      name: '未成年人在监护人指导下浏览',
      value: 'MINOR'
    }]; // 判断是否上传了视频文件

    const hasVideo = computed(() => {
      const fl = uploader.value?.fileList || [];
      return fl.some(item => {
        const type = item.file?.type || '';
        const name = item.file?.name || '';
        if (type.indexOf('video/') !== -1) return true; // iOS/Android 常见视频扩展名兜底

        const videoExts = ['.mp4', '.mov', '.avi', '.wmv', '.flv', '.mkv', '.3gp', '.webm', '.m4v', '.ts'];
        if (videoExts.some(ext => name.toLowerCase().endsWith(ext))) return true;
        return false;
      });
    }); // 内容声明设置右侧显示文本

    const contentDeclareLabel = computed(() => {
      if (!complianceStatement.value) return '请选择'; // 如果合规选择"内容无需标注"，且风险提示有选择 → 显示风险提示选项

      if (complianceStatement.value === 'NONE' && riskWarning.value) {
        const rw = riskWarningOptions.find(o => o.value === riskWarning.value);
        return rw ? rw.name : '请选择';
      } // 其余情况显示合规声明选项


      const cs = complianceOptions.find(o => o.value === complianceStatement.value);
      return cs ? cs.name : '请选择';
    }); // 选择合规声明

    function selectCompliance(value) {
      if (complianceStatement.value === value) {
        complianceStatement.value = '';
      } else {
        complianceStatement.value = value;
      }
    } // 选择风险提示


    function selectRiskWarning(value) {
      if (riskWarning.value === value) {
        riskWarning.value = '';
      } else {
        riskWarning.value = value;
      }
    } // 确定内容声明设置


    function onDeclareConfirm() {
      if (!complianceStatement.value) {
        _Toast('请选择合规声明');

        return;
      }

      contentDeclareShow.value = false;
    }

    async function getCategoryOrTag() {
      if (tid.value && cid.value) {
        const tagRes = await request.getTimelineTag(tid.value);
        form.tagName = tagRes.data.name;
        form.tagId = tagRes.data.id;
        form.tagRes = tagRes;
        const categoryRes = await request.getTimelineCategory(cid.value);
        categroyItem.value = categoryRes.data;
      } else if (tid.value) {
        // 获取话题详情
        canEditTag.value = false;
        const res = await request.getTimelineTag(tid.value);
        categroyItem.value = res.category;
        categroyItem.value.canAnonymous = res.data.canAnonymous; // 特殊处理

        form.tagName = res.data.name;
        form.tagId = res.data.id;
        form.tagRes = res;
      } else if (cid.value) {
        // 获取频道详情
        const res = await request.getTimelineCategory(cid.value);
        categroyItem.value = res.data;
      }
    } // 话题是否配置了表单（只有 isConfig == 1 时才展示表单）


    const formEnabled = () => form.tagRes?.data?.isConfig == 1; // 将获取表单设置到获取话题后执行


    getCategoryOrTag().then(() => publishFormRef.value?.getFormConfig(tid.value, formEnabled())); // 选择地址

    function selectLocation(item) {
      form.address = item ? item.title : '';
      form.location = item ? `${item.point.lat},${item.point.lng}` : '';
    } // 选择话题


    function selectTag(item) {
      form.tagId = item ? item.id : 0;
      form.tagName = item ? item.name : '';
      publishFormRef.value?.getFormConfig(form.tagId, formEnabled());
    } // 提交


    const onSubmit = throttle(async () => {
      try {
        _Toast.loading({
          message: '提交中...',
          forbidClick: true,
          duration: 0
        }); // 表单校验（必填项未填写时组件内部会 throw）


        publishFormRef.value?.validate(); // 内容声明设置验证（视频必填）

        if (hasVideo.value && !complianceStatement.value) {
          _Toast('请选择内容声明设置');

          throw {
            message: '请选择内容声明设置'
          };
        } // 提交自定义表单，拿到 commitId（选项超额等后端错误会向外抛出）


        if (publishFormRef.value?.hasForm()) {
          form.commitId = await publishFormRef.value.commit();
        } // 上传文件


        const files = await uploader.value.uploadFunc(); // 为视频文件添加内容声明字段

        if (hasVideo.value) {
          const fl = uploader.value.fileList || [];
          fl.forEach((item, idx) => {
            const type = item.file?.type || '';
            const name = item.file?.name || '';
            const isVideo = type.indexOf('video/') !== -1 || /\.(mp4|mov|avi|wmv|flv|mkv|3gp|webm|m4v|ts)$/i.test(name);

            if (isVideo && files[idx]) {
              files[idx].complianceStatement = complianceStatement.value;

              if (riskWarning.value) {
                files[idx].riskWarning = riskWarning.value;
              }
            }
          });
        }

        const params = { ...form,
          categoryIds: [categroyItem.value.id],
          files,
          anonymous: anonymous.value
        }; // console.log(params)

        if (form.tagId) params.tagIds = [form.tagId];
        await request.savePost(params);

        _Toast.success('提交成功，等待审核'); // 有任务id
        // debugger


        if (query.taskId && (!query.tid || query.tid && tid.value == query.tid)) {
          onTaskSuccess('2');
        } else {
          goMain();
        }

        _poc_publish(params);
      } catch (error) {
        _Toast.fail(error.message);
      }
    }, 1000);

    function goMain() {
      setTimeout(() => {
        if (tid.value) {
          // 话题
          openCustomPage(`topic/index.html?id=${tid.value}&fs_device=${fs_device}`, true);
        } else {
          openCustomPage(`channel/index.html?id=${categroyItem.value.id}&fs_device=${fs_device}`, true);
        }
      }, 1000);
    }
    /**
     * query search 对象转字符串
     * @param {object} obj
     * @param {boolean} deleteEmpty 是否删除空值
     * @returns
     */


    function stringifyQuerySearch(obj, deleteEmpty = true) {
      const arr = [];
      Object.entries(obj).forEach(([key, value]) => {
        if (deleteEmpty && !value && value !== 0) {
          return;
        }

        arr.push(`${key}=${value}`);
      });
      return arr.join('&');
    } // 营销任务任务完成 taskType: 0-稿件分享、1-稿件评论、2-社区发站


    function onTaskSuccess(type) {
      const param = {};
      const search = window.location.search.split('?')[1];
      const arr = search.split('&');
      arr.forEach(i => {
        const [key, value] = i.split('=');
        param[key] = value;
      });
      const cid = param.cid;
      const taskId = param.taskId;
      const taskType = param.taskType;
      const collId = param.collId;
      const tid = param.tid;
      const memberId = param.memberId;
      if (!taskId) return;
      if (type !== taskType) return;
      const timer1 = setTimeout(() => {
        _Toast.success('完成任务!');

        clearTimeout(timer1);
      }, 800);
      const timer2 = setTimeout(() => {
        const taskQuery = stringifyQuerySearch({
          cid,
          memberId,
          taskId,
          taskType,
          collId,
          tid
        });
        const url = `${location.origin}/fs-web-1/marketing-promotion-2024/#/award?${taskQuery}`;
        location.replace(url);
        clearTimeout(timer2);
      }, 1500);
    }

    setTimeout(() => {
      if (localStorage.getItem('_user_id')) {
        // eslint-disable-next-line no-undef
        qaplus.event.setMetaInfo(localStorage.getItem('_user_id')); // eslint-disable-next-line no-undef

        pocplus.event.config('user_unique_id', localStorage.getItem('_user_id'));
      }
    }, 500);

    function _poc_publish(info) {
      let _poc_event_params = {
        post_channel: '友趣',
        member_id: localStorage.getItem('_user_id'),
        channel_id: info.channel_id,
        channel_name: categroyItem.value.name,
        topic_id: info.tagId,
        topic_name: info.tagName
      }; // eslint-disable-next-line no-undef

      qaplus.event.record('fsp_post_release', 19999, _poc_event_params); // eslint-disable-next-line no-undef

      pocplus.event.record('fsplusmp_community_post_submit', _poc_event_params);
    }

    const isMini = computed(() => {
      return ua.isMini;
    });
    return (_ctx, _cache) => {
      const _component_van_field = _resolveComponent("van-field");

      const _component_van_switch = _resolveComponent("van-switch");

      const _component_van_cell = _resolveComponent("van-cell");

      const _component_van_button = _resolveComponent("van-button");

      const _component_van_form = _resolveComponent("van-form");

      const _component_van_icon = _resolveComponent("van-icon");

      const _component_van_popup = _resolveComponent("van-popup");

      return _openBlock(), _createBlock(CPage, {
        "is-publish": true
      }, {
        main: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, "发布在" + _toDisplayString(categroyItem.value ? categroyItem.value.name : ''), 1), _createVNode(UploadView, {
          ref_key: "uploader",
          ref: uploader,
          class: "line-section"
        }, null, 512), _createVNode(_component_van_form, {
          onSubmit: _unref(onSubmit)
        }, {
          default: _withCtx(() => [_createVNode(_component_van_field, {
            class: "line-section input-field",
            modelValue: _unref(form).content,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(form).content = $event),
            size: 'large',
            autosize: true,
            rows: "5",
            type: "textarea",
            maxlength: "500",
            placeholder: "请输入",
            "show-word-limit": "",
            rules: [{
              required: true,
              message: '请填写内容'
            }]
          }, null, 8, ["modelValue"]), categroyItem.value.canAnonymous == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_hoisted_4, _createVNode(_component_van_switch, {
            modelValue: anonymous.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => anonymous.value = $event),
            size: "20px",
            "active-color": "#FF2340"
          }, null, 8, ["modelValue"])])) : _createCommentVNode("", true), _unref(hasVideo) ? (_openBlock(), _createBlock(_component_van_cell, {
            key: 1,
            class: "content-declare-cell",
            "is-link": "",
            required: true,
            title: "内容声明设置",
            value: _unref(contentDeclareLabel),
            onClick: _cache[2] || (_cache[2] = $event => contentDeclareShow.value = true)
          }, null, 8, ["value"])) : _createCommentVNode("", true), _createVNode(PublishForm, {
            ref_key: "publishFormRef",
            ref: publishFormRef
          }, null, 512), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [!_unref(isMini) ? (_openBlock(), _createBlock(SelectLocationView, {
            key: 0,
            onSelectLocation: selectLocation
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_7, [_hoisted_8, _createElementVNode("p", null, _toDisplayString(_unref(form).address ? _unref(form).address : '添加定位'), 1)])]),
            _: 1
          })) : _createCommentVNode("", true), _createVNode(SelectTagView, {
            cid: categroyItem.value.id,
            canEdit: canEditTag.value,
            onSelectTag: selectTag
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_9, [_hoisted_10, _createElementVNode("p", null, _toDisplayString(_unref(form).tagName ? _unref(form).tagName : '添加话题'), 1)])]),
            _: 1
          }, 8, ["cid", "canEdit"])]), _createVNode(_component_van_button, {
            class: "submit-btn",
            "native-type": "submit"
          }, {
            default: _withCtx(() => [_hoisted_11]),
            _: 1
          })])]),
          _: 1
        }, 8, ["onSubmit"])]), _createVNode(BindPhone), _createVNode(_component_van_popup, {
          show: contentDeclareShow.value,
          "onUpdate:show": _cache[4] || (_cache[4] = $event => contentDeclareShow.value = $event),
          round: "",
          position: "bottom",
          style: {
            height: '90%'
          },
          "safe-area-inset-bottom": ""
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_hoisted_14, _createVNode(_component_van_icon, {
            name: "cross",
            size: "20",
            onClick: _cache[3] || (_cache[3] = $event => contentDeclareShow.value = false)
          })]), _createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_hoisted_17, (_openBlock(), _createElementBlock(_Fragment, null, _renderList(complianceOptions, item => {
            return _createElementVNode("div", {
              key: item.value,
              class: _normalizeClass(["option-item", {
                selected: complianceStatement.value === item.value
              }]),
              onClick: $event => selectCompliance(item.value)
            }, [_createElementVNode("span", _hoisted_19, _toDisplayString(item.name), 1), complianceStatement.value === item.value ? (_openBlock(), _createBlock(_component_van_icon, {
              key: 0,
              name: "success",
              color: "#FF2340",
              size: "18"
            })) : _createCommentVNode("", true)], 10, _hoisted_18);
          }), 64))]), _createElementVNode("div", _hoisted_20, [_hoisted_21, (_openBlock(), _createElementBlock(_Fragment, null, _renderList(riskWarningOptions, item => {
            return _createElementVNode("div", {
              key: item.value,
              class: _normalizeClass(["option-item", {
                selected: riskWarning.value === item.value
              }]),
              onClick: $event => selectRiskWarning(item.value)
            }, [_createElementVNode("span", _hoisted_23, _toDisplayString(item.name), 1), riskWarning.value === item.value ? (_openBlock(), _createBlock(_component_van_icon, {
              key: 0,
              name: "success",
              color: "#FF2340",
              size: "18"
            })) : _createCommentVNode("", true)], 10, _hoisted_22);
          }), 64))])]), _createElementVNode("div", _hoisted_24, [_createVNode(_component_van_button, {
            class: "confirm-btn",
            block: "",
            onClick: onDeclareConfirm
          }, {
            default: _withCtx(() => [_hoisted_25]),
            _: 1
          })])])]),
          _: 1
        }, 8, ["show"])]),
        _: 1
      });
    };
  }

};